const { READ_ONLY_FEATURES } = process.env;

const attributeNameEnum = {
    "org.openvmr.v1_0.schema.IVLTS": 'IVL_TS',
    "org.openvmr.v1_0.schema.TS": 'TS',
    "org.openvmr.v1_0.schema.II": 'II',
    "org.openvmr.v1_0.schema.CD": 'CD',
    "org.openvmr.v1_0.schema.BL": 'BL',
    "org.openvmr.v1_0.schema.PQ": 'PQ'
};

const templateNameEnum = {
    "org.openvmr.v1_0.schema.EncounterEvent": 'EncounterEvent',
    "org.openvmr.v1_0.schema.EvaluatedPerson": 'EvaluatedPerson',
    "org.opencds.vmr.v1_0.schema.ObservationOrder": 'ObservationOrder',
    "org.openvmr.v1_0.schema.ObservationResult": 'ObservationResult',
    "org.openvmr.v1_0.schema.Problem": 'Problem',
    "org.openvmr.v1_0.schema.SubstanceAdministrationEvent": 'SubstanceAdministrationEvent',
    "org.openvmr.v1_0.schema.SubstanceAdministrationOrder": 'SubstanceAdministrationOrder'
};

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete', 'insert'];

const uiConfig = {
    name: 'Input Nodes',
    withActions: actions,
    primaryKey: 'nodeId',
    properties: {
        "templateClassName": {
            name: "Template Class",
            options: templateNameEnum,
            input: "select",
            rowDisplay: false,
            editable: true,
            nullable: false,
            postChangeBind: (v, onChange) => {
                onChange('templateName', templateNameEnum[v], true)
            }
        },
        "templateName": {
            name: "Template Class",
            rowDisplay: true,
            editable: false,
            nullable: false,
            filterable: true,
        },
        "nodePath": {
            name: "Node Path",
            rowDisplay: true,
            input: 'text',
            editable: true,
            nullable: false,
            filterable: true,
        },
        "attributeClassName": {
            name: "Node Class",
            input: 'select',
            options: attributeNameEnum,
            postChangeBind: (v, onChange) => {
                onChange('attributeName', attributeNameEnum[v], true)
            },
            rowDisplay: false,
            editable: true,
            nullable: false,
        },
        "attributeName": {
            name: "Node Class",
            rowDisplay: true,
            editable: false,
            nullable: false,
            filterable: true,
        },
        "createDatetime": {
            name: "Created Datetime",
            rowDisplay: false,
            editable: false,
        },
        "createId": {
            name: "Created by",
            rowDisplay: false,
            editable: false,
        },
        "dtoState": {
            name: "DTO State",
            rowDisplay: false,
            editable: false
        },
        "lastModDatetime": {
            name: "Last Modified",
            rowDisplay: false,
            editable: false
        },
        "lastModId": {
            name: "Last Modified By",
            rowDisplay: false,
            editable: false
        },
        "nodeId": {
            name: "Node Id",
            rowDisplay: false,
            editable: false,
            nullable: false,
        },
        "uuid": {
            name: "UUID",
            rowDisplay: false,
            editable: false
        }
    },
    newDoc: {
        "attributeClassName": null,
        "attributeName": null,
        "dtoState": "NEW",
        "nodeId": null,
        "nodePath": null,
        "templateClassName": null,
        "templateName": null,
    }
};

export default uiConfig;